import React from 'react';
import config from "../../../../config";

type Cats = {
    id: string | number,
    name: string
}[]

interface CategoriesListProps {
    cats: Cats;
}

const CategoriesList: React.FC<CategoriesListProps> = (props) => {
    const cats = props.cats;

    const handleClick = (catId: string | number) => {
        window.location.href = `${config.WEB_URL_ROOT}blog?category_id=${catId}`
    }

    return (
        <ul className="list-unstyled">
        {
            cats.map(category => (
                <li className="cursor-pointer" onClick={() => handleClick(category.id)} key={category.id}>{category.name}</li>
            ))
        }
        </ul>
    );
}

export default CategoriesList;
